// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"c13e2b11","223":"dff21f14","239":"e39fb35b","389":"600974ad","453":"03346f77","455":"a9ba13ed","977":"240addac"}[chunkId] + ".chunk.js";
};